import React from 'react';
import { Navigate, useParams } from 'react-router-dom';
import { findMenuItem } from './myPageMenu';

// 아직 구현되지 않은 마이페이지 메뉴의 공통 안내 화면. 메뉴에 없는 경로는 기본 정보로 보낸다.
export default function ComingSoonSection() {
    const { section } = useParams();
    const item = findMenuItem(section);
    if (!item) return <Navigate to="/mypage/profile" replace />;

    return <>
        <div className="my-page-section-heading"><div><h2>{item.label}</h2><p>곧 이용할 수 있도록 준비하고 있습니다.</p></div></div>
        <div className="my-page-card my-page-placeholder"><h3>준비 중입니다 <small>준비 중</small></h3><p>{item.description}</p></div>
    </>;
}
